// extracted by mini-css-extract-plugin
export var pillWrapper = "_is-0";
export var showOverflow = "_is-1";